<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>ANVT - Agence Nationale du Volontariat Togo</title>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        body {
            background: #ffffff;
            color: #333333;
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 20px;
        }

        .container {
            background: #ffffff;
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
            max-width: 800px;
            width: 100%;
            padding: 40px;
            text-align: center;
        }

        .logo-container {
            margin: 0 auto 30px;
            width: 150px;
            height: 150px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            border: 4px solid #f0f0f0;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        .logo-container img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        h1 {
            font-size: 2rem;
            margin-bottom: 15px;
            color: #055588;
            font-weight: 700;
        }

        .tagline {
            font-size: 1.1rem;
            margin-bottom: 30px;
            color: #555555;
            max-width: 500px;
            margin-left: auto;
            margin-right: auto;
            line-height: 1.5;
        }

        .options-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 20px;
            margin: 30px 0;
        }

        .option-box {
            background: #ffffff;
            border-radius: 12px;
            padding: 25px;
            width: 100%;
            max-width: 300px;
            text-align: center;
            border: 1px solid #eeeeee;
        }

        .option-box i {
            font-size: 2.5rem;
            margin-bottom: 15px;
            color: #fec106;
        }

        .option-box h3 {
            font-size: 1.4rem;
            margin-bottom: 12px;
            color: #055588;
        }

        .option-box p {
            color: #666666;
            line-height: 1.5;
            margin-bottom: 20px;
            font-size: 0.95rem;
        }

        .btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            background: #055588;
            color: white;
            text-decoration: none;
            font-size: 0.95rem;
            font-weight: 600;
            padding: 10px 20px;
            border-radius: 50px;
            transition: all 0.3s ease;
            border: 2px solid #055588;
            width: 100%;
            max-width: 220px;
            margin: 0 auto;
        }

        .btn:hover {
            background: transparent;
            color: #055588;
        }

        .recommendation {
            background: #f9f9f9;
            border-radius: 12px;
            padding: 20px;
            margin: 30px 0;
            border-left: 3px solid #fec106;
            text-align: left;
        }

        .recommendation h3 {
            display: flex;
            align-items: center;
            gap: 8px;
            color: #055588;
            margin-bottom: 12px;
            font-size: 1.2rem;
        }

        .recommendation h3 i {
            color: #fec106;
        }

        .recommendation p {
            color: #555555;
            line-height: 1.5;
            margin-bottom: 8px;
            font-size: 0.95rem;
        }

        .footer {
            margin-top: 30px;
            color: #777777;
            font-size: 0.85rem;
            border-top: 1px solid #eeeeee;
            padding-top: 15px;
            width: 100%;
        }

        @media (max-width: 768px) {
            .container {
                padding: 30px 20px;
            }

            .logo-container {
                width: 120px;
                height: 120px;
            }

            h1 {
                font-size: 1.7rem;
            }

            .tagline {
                font-size: 1rem;
            }

            .options-container {
                flex-direction: column;
                align-items: center;
            }

            .option-box {
                max-width: 100%;
            }
        }
    </style>
</head>
<body>
<div class="container">
    <div class="logo-container">
        <img src="assets/images/logo/logoanvt1.jpg" alt="Logo ANVT">
    </div>

    <h1>Agence Nationale du Volontariat Togo</h1>
    <p class="tagline">Accédez à nos services selon votre appareil pour une expérience optimale</p>

    <div class="options-container">
        <div class="option-box">
            <i class="fas fa-mobile-alt"></i>
            <h3>Application Mobile</h3>
            <p>Téléchargez notre application officielle (ANVT) sur Google Play Store pour votre smartphone.</p>
            <a href="https://play.google.com/store/apps/details?id=com.anvt.vnmobile.public&pcampaignid=web_share" class="btn" target="_blank">
                <i class="fab fa-google-play"></i>
                Télécharger l'application
            </a>
        </div>

        <div class="option-box">
            <i class="fas fa-laptop"></i>
            <h3>Site Web</h3>
            <p>Utilisez notre site web depuis votre ordinateur pour une navigation complète.</p>
            <a href="#" class="btn">
                <i class="fas fa-globe"></i>
                Accéder au site
            </a>
        </div>
    </div>

    <div class="recommendation">
        <h3><i class="fas fa-info-circle"></i> Recommandation</h3>
        <p>Pour une meilleure expérience :</p>
        <p>• Sur mobile : Utilisez notre application "ANVT" disponible sur Play Store</p>
        <p>• Sur ordinateur : Accédez à notre site web</p>
    </div>

    <div class="footer">
        <p>© 2023 ANVT - Agence Nationale du Volontariat Togo. Tous droits réservés.</p>
    </div>
</div>
</body>
</html>